export default __webpack_public_path__ + "static/media/addItemPortfolioImg.170d91e0.png";